import React from "react";
import { Col, Form } from "react-bootstrap";

const SearchApp = () => {
  return (
    <>
      <Col sm className="search">
        <Form>
          <Form.Group className="mb-3" controlId="formSearch">
            <Form.Control size="sm" type="email" placeholder="Rechercher..." />
          </Form.Group>
        </Form>
      </Col>
    </>
  );
};

export default SearchApp;
